import { render } from "./BatteryDetails.vue?vue&type=template&id=685cba47&scoped=true"
import script from "./BatteryDetails.vue?vue&type=script&lang=js"
export * from "./BatteryDetails.vue?vue&type=script&lang=js"

import "./BatteryDetails.vue?vue&type=style&index=0&id=685cba47&lang=scss&scoped=true"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685cba47"]])

export default __exports__